import React from 'react';
import { ChecklistCell } from './ChecklistCell';
import type {
  ChecklistClearAll,
  ChecklistFooter,
  ChecklistOption,
} from '../checklist';

export type MultiSelectCellProps = {
  options: readonly ChecklistOption[];
  value: readonly string[];
  /** Called on every tick, with the picked values in the options' order. */
  onChange: (value: string[]) => void;
  /** Shown when nothing is picked. */
  placeholder?: string;
  ariaLabel: string;
  disabled?: boolean;
  /** Shown in the cell instead of the picked labels. */
  text?: string;
  /** A last row in the list that closes it and runs an action. */
  footer?: ChecklistFooter;
  /** "Clear all" with its own action, instead of unticking what is shown. */
  clearAll?: ChecklistClearAll;
};

/** A cell holding any number of values, picked from a checklist that stays open. */
export const MultiSelectCell: React.FC<MultiSelectCellProps> = props => (
  <ChecklistCell {...props} />
);
